import React from "react";
import { Link } from "react-router-dom";
import { Button, Skeleton } from "antd";
import moment from "moment";

import "./sidebar.css";
import { BtnArchieveOrder } from "../buttons/BtnArchieveOrder";
import OrderSurcharge from "../OrderSurcharge/OrderSurcharge";
import OrderAssignDriver from "../OrderAssignDriver";

moment.locale("ru");

class Sidebar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      okButtonDisabled: true,
      docsDrawerVisible: false
    };
  }

  // downloadNotificationToGibdd = () => {
  //   this.props.downloadNotificationInGibdd({
  //     number: this.props.order.number,
  //     orderId: this.props.orderId,
  //     emailgibdd: this.props.order.gibddMail
  //   });
  // };

  totalPrice = (predPayPrice = 0, payPrice = 0, postPayPrice = 0) => {
    const predPay =
      (predPayPrice &&
        Array.isArray(predPayPrice) &&
        predPayPrice.length > 0 &&
        predPayPrice
          .map((_, index) => {
            return this.props.order[`predPayPrice${index}`];
          })
          .reduce((acc, curr) => acc + curr)) ||
      0;

    const postPay =
      (predPayPrice &&
        Array.isArray(predPayPrice) &&
        predPayPrice.length > 0 &&
        predPayPrice
          .map((_, index) => {
            return this.props.order[`postPayPrice${index}`];
          })
          .reduce((acc, curr) => acc + curr)) ||
      0;

    return predPay + payPrice + postPay;
  };

  render() {
    const { order } = this.props;
    const isDrivers = order && order.driverId;
    const isVehicle = order && order.vehicleId;
    const responsible = order && order.responsible;
    const driver = order && order.driver;
    const driverId = order && order.driverId;
    const vehicle = order && order.vehicle;
    const vehicleId = order && order.vehicleId;

    const responsibleId = responsible && responsible.profileId;
    const responsibleName =
      responsible &&
      responsible.userId &&
      responsible.userId.lastname &&
      responsible.userId.name &&
      responsible.userId.patronymic &&
      `${responsible.userId.lastname ? responsible.userId.lastname : ""} ${
        responsible.userId.name ? responsible.userId.name[0] + "." : ""
      } ${
        responsible.userId.patronymic
          ? responsible.userId.patronymic[0] + "."
          : ""
      }`;

    // const isKids = order && order.serviceType && order.serviceType === "kids";
    return !order ? null : (
      <div className="sidebar">
        <Link to={`/order/${order.id}/documents`} target={"_blank"}>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            className="orders-create__links"
          >
            Документы
          </Button>
        </Link>
        <Button
          type="primary"
          htmlType="submit"
          size="large"
          ghost
          className="orders-create__links"
          style={{ marginBottom: 16 }}
          onClick={this.props.showOrderReportDrawer}
        >
          Отчёт по заказу
        </Button>
        <div className="sidebar-info price-info" style={{ marginTop: "0" }}>
          {(order && order.payChecked) ||
          (order && order.predPayChecked) ||
          (order && order.postPayChecked) ? (
            <div className="line-content">
              <span className="line-content__header">
                {this.totalPrice(order.predPay, order.payPrice, order.postPay)}{" "}
                ₽
              </span>
              {order.predPayChecked &&
                order.predPay.map((item, index) => {
                  return (
                    <div key={index} className="line-content__row">
                      <div className="line-content__column">
                        <span className="line-content__title">Предоплата</span>
                        <span className="line-content__text">
                          {order["predPayPrice" + index]} ₽
                        </span>
                      </div>
                      <div className="line-content__column">
                        <span className="line-content__additional">
                          до&nbsp;
                          {order["predPaymentTime" + index].format(
                            "DD.MM.YYYY"
                          )}
                        </span>
                        <span className="line-content__additional">
                          {order["predPaymentTime" + index].format("HH:mm")}
                        </span>
                      </div>
                    </div>
                  );
                })}
              {order && order.payPrice && order.paymentTime && (
                <div className="line-content__row">
                  <div className="line-content__column">
                    <span className="line-content__title">При посадке</span>
                    <span className="line-content__text">
                      {order.payPrice} ₽
                    </span>
                  </div>
                  <div className="line-content__column">
                    <span className="line-content__additional">
                      до&nbsp;{order["paymentTime"].format("DD.MM.YYYY")}
                    </span>
                  </div>
                </div>
              )}
              {order.postPayChecked &&
                order.postPay.map((item, index) => {
                  return (
                    <div key={index} className="line-content__row">
                      <div className="line-content__column">
                        <span className="line-content__title">Постоплата</span>
                        <span className="line-content__text">
                          {order["postPayPrice" + index]} ₽
                        </span>
                      </div>
                      <div className="line-content__column">
                        <span className="line-content__additional">
                          до&nbsp;
                          {order["postPaymentTime" + index].format(
                            "DD.MM.YYYY"
                          )}
                        </span>
                        <span className="line-content__additional">
                          {order["postPaymentTime" + index].format("HH:mm")}
                        </span>
                      </div>
                    </div>
                  );
                })}
              <OrderSurcharge order={this.props.order} />
            </div>
          ) : (
            <Skeleton active />
          )}
        </div>

        {order && (
          <div className="sidebar-info status-info">
            <div className="sidebar-info__header">Статус заказа</div>
            <div className="line-content">
              <div className="line-content__row">
                <div className="line-content__column">
                  <span className="line-content__title">
                    {order.orderStatusName}
                  </span>
                </div>
                <div className="line-content__column">
                  <span className="line-content__additional">
                    {order.arrivalDatetime.format("DD.MM.YYYY")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
        {/*

        КНОПКИ ПОКА СКРЫТЫ, ПОКА НЕ РЕШИТСЯ ВОПРОС РЕДАКТИРОВАНИЯ ЗАКАЗА

        */}
        {/*<Button type="primary" ghost size="large">*/}
        {/*  {isVehicle ? "Сменить ТС" : "Назначить ТС"}*/}
        {/*</Button>*/}

        <OrderAssignDriver data={order} isDrivers={isDrivers}/>
        {(isDrivers || isVehicle) && (
          <div className="order-list-sidebar__block block">
            {(driver && driverId) ||
            (vehicle && vehicleId) ||
            (responsibleName && responsibleId) ? (
              <div className="block__list">
                {driver && driverId && (
                  <div className="block__list-item">
                    <span className="block__label">Водитель</span>
                    <Link
                      to={`/employees/${driverId}`}
                      className="block__text color-text-blue"
                    >
                      {driver}
                    </Link>
                  </div>
                )}
                {vehicle && vehicleId && (
                  <div className="block__list-item">
                    <span className="block__label">ТС</span>
                    <Link
                      to={`/vehicle_card/${vehicleId}`}
                      className="block__text color-text-blue"
                    >
                      {vehicle}
                    </Link>
                  </div>
                )}
                {responsibleName && responsibleId && (
                  <div className="block__list-item">
                    <span className="block__label">Ответств.</span>
                    <Link
                      to={`/employees/${responsibleId}`}
                      className="block__text color-text-blue"
                    >
                      {responsibleName}
                    </Link>
                  </div>
                )}
              </div>
            ) : (
              <Skeleton active />
            )}
          </div>
        )}
        {order.orderStatus !== "archivecarrier" &&
          order.orderStatus !== "archagreement" && (
            <BtnArchieveOrder onClick={this.props.handleClickDelete} />
          )}

        <Button
          type="danger"
          htmlType="submit"
          size="large"
          className="offer-card-btn"
          onClick={() => this.props.handleBackButton()}
          ghost
        >
          Назад
        </Button>
      </div>
    );
  }
}

export default Sidebar;
